// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"ChatWebClient-8e6aaa0d62eb36a0","iframe":"ChatWebClient-bc95914eb432830a"};